module.exports = __webpack_public_path__ + "static/media/Close.aeec2863.svg";